import React, { Component } from "react"
import PropTypes from 'prop-types'
import MdWarning from 'react-icons/lib/md/warning'
var msgInterval = null;
var msgTimeout = null;
let confirmTimeout = 5;
class ConfirmSubmitButton extends Component {
    constructor (props) {
        super(props)
                
        this.state = {
            confirmationMode: false,
            didClick: false,
            tick: ' ( ' + confirmTimeout + ' )'
        }

        this.handleClick = this.handleClick.bind(this)
    }

    componentWillUnmount (){
        if (msgInterval !== null){
            clearInterval(msgInterval);
        }
        if (msgTimeout !== null){
            clearTimeout(msgTimeout);
        }
    }
    
    handleClick (ev) {
        ev && ev.preventDefault()
        

        this.setState(state => ({
            confirmationMode: !state.confirmationMode
        }))
        
        // Wait 2 seconds for them to confirm then revert automatically
        if (!this.state.confirmationMode) {
            var ticking = confirmTimeout;
            msgInterval = setInterval(() => {
                ticking --;
                // update text 
                this.setState(state => ({
                    tick: ' ( ' + ticking + ' )'
                }));
            }, 1000);

            msgTimeout = setTimeout(() => {
                this.setState(state => ({
                    confirmationMode: false
                }));
                clearInterval(msgInterval);
                this.setState(state => ({
                    tick: ' ( ' + confirmTimeout + ' )'
                }));
            }, confirmTimeout * 1000);
        } else {
            this.props.handleSubmit();
            this.setState({
                didClick: true
            });
        }
    } 

    render () {
        let { confirmationMode, didClick, tick } = this.state
        let { className, verb, icon, disabled } = this.props
        
        let buttonLabel

        if (confirmationMode) {
            className = "btn btn-info"
            icon = <MdWarning/>
            buttonLabel = 'Please confirm ' + verb + tick;
        } else {
            buttonLabel = verb
        }

        if (didClick) {
            icon = null
            disabled = true
            className = "btn btn-default"
            buttonLabel = <span>Updating &hellip;</span>
        }
        
        return <button
            style={{ outline: 'none' }}
            onClick={this.handleClick}
            disabled={disabled}
            className={className}>
            {icon} {buttonLabel}
        </button>
    }
}

ConfirmSubmitButton.propTypes = {}

export default ConfirmSubmitButton